import { render, staticRenderFns } from "./batch-generate-prove.vue?vue&type=template&id=be7aa574&scoped=true&"
import script from "./batch-generate-prove.js?vue&type=script&lang=js&"
export * from "./batch-generate-prove.js?vue&type=script&lang=js&"
import style0 from "./batch-generate-prove.vue?vue&type=style&index=0&id=be7aa574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7aa574",
  null
  
)

export default component.exports